<div class="comment-box" v-for="(comment, index) in limitedComments || []" :key="comment.id">
  <!-- Parent Comment -->
<div class="d-flex align-items-start mb-3 w-100">
<div class="comment-avatar-wrapper me-2">
  <img
    v-if="get_profile_picture(comment)"
    :src="get_profile_picture(comment)"
    class="comment-avatar"
    alt="Profile Picture"
  >
  <i
    v-else
    class="bi bi-person-circle fs-4 text-dark pointer "
  ></i>
</div>

  <div class="flex-grow-1">
    <div class="d-flex align-items-center justify-content-between w-100">
      <div class="text-xs">
        <strong v-if="comment?.base_profile.user?.is_blocked" class="text-muted">Unknown User</strong>
        <strong v-else class="pointer">
          <span v-if="comment?.base_profile?.profile_type=='business'" @click="view_company(comment)">
            {{ comment?.base_profile?.company.company_name }}
          </span>
          <span v-else @click="view_profile(comment.base_profile?.user?.id)">
            {{ comment.base_profile?.user?.first_name }} {{ comment.base_profile?.user?.last_name }}
          </span>
        </strong>
        <span class="comment-meta text-muted ms-1">• {{ comment.time }}</span>
      </div>

      <div class="dropdown" v-if="token_exists && (String(comment.base_profile?.user?.id) === String(user_id) || user_details.user_role === 'admin' || portal_admin)">
        <button class="btn btn-sm p-0 border-0" type="button" data-bs-toggle="dropdown">
          <i class="bi bi-three-dots-vertical text-muted"></i>
        </button>
        <ul class="dropdown-menu dropdown-menu-end text-xs">
          <li v-if="String(comment.base_profile?.user?.id) === String(user_id)">
            <a class="dropdown-item" @click="edit_comment(comment)">Edit</a>
          </li>
          <li><a class="dropdown-item text-danger" @click="delete_comment(comment.id)">Delete</a></li>
        </ul>
      </div>
    </div>

    <div class="text-xs mt-1 mb-2" v-html="highlightTaggedUsers(comment.comment_text)"></div>

    <div class="d-flex align-items-center border rounded "  v-if="editing_comment_id === comment.id">
       <div class="comment-avatar-wrapper me-2">
        <img
          v-if="get_personal_profile_picture(activeProfile.user?.profile?.profile_files)"
          :src="get_personal_profile_picture(activeProfile.user?.profile?.profile_files)"
          class="comment-avatar"
          alt="Profile Picture"
        >
        <i
          v-else
          class="bi bi-person-circle fs-2 text-dark pointer"
        ></i>
      </div>

        <div class="input-group rounded-5">
          <input
          type="text"
          class="form-control border-0 rounded-5 text-xs"
          v-model="editing_comment_text"
          placeholder="Edit your comment"/>

           <div class="d-flex align-items-center">
              <button class="btn btn-sm text-xxs" type="button" id="button-addon2"
                @click="save_edit_comment(comment.id)"><i class="bi bi-send-fill text-black fs-6"></i></button>
            </div>

    </div>


    </div>

   

    <div class="d-flex align-items-center w-100">
      <span 
        class="fw-bold text-xxs me-3 pointer d-flex align-items-center" 
        :class="{ 'text-primary': comment.user_liked }"
        @click.stop="toggleCommentLike(comment)"
      >
        <i class="bi me-1" :class="comment.user_liked ? 'bi-hand-thumbs-up-fill' : 'bi-hand-thumbs-up'"></i>
        {{ comment.user_liked ? 'Liked' : 'Like' }}
      </span>

      <span class="fw-bold text-xxs me-3 pointer" @click.stop="toggler_comment_input(comment.id)">
        Reply <i class="bi bi-reply"></i>
      </span>

      <span 
        class="text-primary text-xxs fw-bold pointer" 
        v-if="comment.reply_comment?.length" 
        @click.stop="toggleReplies(comment.id)"
      >
        {{ visible_replies_map[comment.id] ? 'See less' : 'View (' + comment.reply_comment.length + ') replies' }}
      </span>

      <span 
        v-if="comment.likes_count > 0" 
        class="text-muted text-xxs ms-auto pointer" 
        @click.stop="selectedReport(comment)"
      >
        {{ comment.likes_count }} {{ comment.likes_count === 1 ? 'Like' : 'Likes' }}
      </span>
    </div>

    <div v-if="showReplyInput[comment.id]" class="d-flex align-items-center border rounded mt-2 px-2" @click.stop>
      <div class="comment-avatar-wrapper me-2">
        <img
          v-if="get_personal_profile_picture(activeProfile.user?.profile?.profile_files)"
          :src="get_personal_profile_picture(activeProfile.user?.profile?.profile_files)"
          class="comment-avatar"
          alt="Profile Picture"
        >
        <i
          v-else
          class="bi bi-person-circle fs-4 text-dark pointer"></i>
      </div>
      <input
        class="form-control form-control-sm border-0 bg-transparent text-xxs"
        v-model="replyTexts[comment.id]"
        type="text"
        placeholder="Write a reply..."
      />
      <button class="btn btn-sm text-xxs" type="button" id="button-addon2"
        @click.stop="submit_reply(comment.id)"><i class="bi bi-send-fill text-black fs-6"></i></button>
    </div>

    <div v-if="visible_replies_map[comment.id]" class="mt-3 ps-2 ">
       <div v-for="reply in comment.reply_comment" :key="reply.id" class="d-flex align-items-start mb-2 w-100">

        <div class="comment-avatar-wrapper me-2">
          <img
            v-if="get_profile_picture(reply)"
            :src="get_profile_picture(reply)"
            class="comment-avatar"
            alt="Profile Picture"
          >
          <i
            v-else
            class="bi bi-person-circle fs-5 text-dark pointer"
          ></i>
        </div>
          <div class="flex-grow-1 justify-content-between w-100">

             <div class="text-xs">
              <strong v-if= "reply?.base_profile?.user?.is_blocked">
                Unknown User
              </strong>
              <strong v-else>
                  <span v-if="reply.base_profile.profile_type=='business'"  @click="view_company(reply)">

                    {{ reply.base_profile.company.company_name }}
                  </span>
                  <span v-else @click="view_profile(reply.base_profile?.user?.id)">
                    {{reply.base_profile.user?.first_name}} {{reply.base_profile.user?.last_name}}
                  </span>
              </strong>
              <span class="text-muted ms-1 text-xxs">• {{ reply.time }}</span>
            </div>
             <div class="text-xs">
                <div class="text-xs">{{ reply.reply }}</div>
             </div>
          </div>
       </div>
    </div>

  </div>
</div>
</div>


<!-- Show more comments -->
<div v-if="comments_data.length > 3" class="mt-2 text-center">
  <span
    class="text-primary text-xs fw-bold reply-toggler-button d-inline-flex align-items-center"
    @click.stop="toggleComments"
  >
    {{ showAllComments ? 'See less comments' : 'See more comments' }}
  </span>
</div>

<!-- Likes Modal -->
<teleport to="body">
<div v-if="show_comment_like" class="modal fade" id="likesModal" tabindex="-1" aria-labelledby="likesModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content border-0 shadow rounded-3">
      <div class="modal-header border-0 pb-0">
        <h5 class="modal-title fw-bold" id="likesModalLabel">Liked by</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body pt-2">
        <ul class="list-group list-group-flush">
          <li v-if="selectedCommentLikes.length > 0"
            v-for="like in selectedCommentLikes"
            :key="like.id"
            class="list-group-item d-flex justify-content-between align-items-center"

          >
            <div class="d-flex align-items-center">
              <img
                :src="like.base_profile?.profile_files?.[0]?.file?.file_url || require('@/assets/images/user.png')"
                class="rounded-circle me-2"
                width="32"
                height="32"
              >
              <span class="text-xs">
                <strong v-if="like?.base_profile.user?.is_blocked">
                  Unknown User
                </strong>

                <strong v-if="like.base_profile.profile_type === 'personal'">
                  {{ like.base_profile?.user?.first_name }} {{ like.base_profile?.user?.last_name }}
                </strong>

                <strong v-else-if="like.base_profile.profile_type === 'business'">
                  {{ like.base_profile?.company?.company_name || 'Company Name'}}
                </strong>
              </span>
            </div>
            <i class="bi bi-hand-thumbs-up text-primary"></i>
          </li>
          <p v-else> No likes yet.</p>
        </ul>

      </div>
    </div>
  </div>
</div>
</teleport>
